import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=13707622&scoped=true&"
import script from "./CardButton.vue?vue&type=script&lang=js&"
export * from "./CardButton.vue?vue&type=script&lang=js&"
import style0 from "./CardButton.vue?vue&type=style&index=0&id=13707622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13707622",
  null
  
)

export default component.exports